import { appStakeUnstakePopupState } from "@/atoms/appPopupState"
import { restakingBalancesAtom } from "@/atoms/restakingState"
import Button from "@/components/base/Button"
import ItemInfo from "@/components/staking/components/detail/components/shared/ItemInfo"
import useRestaking from "@/hooks/useRestaking"
import useTrans from "@/hooks/useTrans"
import { REL, STAKING, UNSTAKING } from "@/utils/constants"
import { TokenSymbol, tokenDecimalDigits } from "@/utils/helpers"
import { formatToken } from "@/utils/numberFormatter"
import { Stack } from "@mui/material"
import { useAtom } from "jotai"
import React, { useMemo } from "react"
import { StakeUnstakeForm } from "../stakeUnstakeForm"

type StakeProps = {
  handleOpenStakingModal: (type: typeof STAKING | typeof UNSTAKING) => void
}

const Stake = ({ handleOpenStakingModal }: StakeProps) => {
  const trans = useTrans()
  const { stakingItemInfo } = useRestaking()
  const [restakingBalances] = useAtom(restakingBalancesAtom)
  const [popupState] = useAtom(appStakeUnstakePopupState)

  const stakeTokenDisplay = useMemo(() => {
    if (!restakingBalances.stakeToken) return "0"

    return formatToken(
      restakingBalances.stakeToken,
      tokenDecimalDigits[(stakingItemInfo?.symbol as TokenSymbol) ?? REL],
      false,
      false,
      undefined,
      false,
      {},
    )
  }, [restakingBalances.stakeToken, stakingItemInfo?.symbol])

  return (
    <Stack className='mt-4' gap={1} data-testid='staking-detail-stake'>
      <Stack direction='row' justifyContent='space-between' alignItems='start' gap={1}>
        <ItemInfo title={trans.staking.detail.rel_wallet_balance} value={stakeTokenDisplay} />

        {popupState.isOpen && popupState.type !== STAKING && (
          <Button
            variant='primary'
            size='md'
            className='w-32'
            onClick={() => handleOpenStakingModal("staking")}
            data-testid='staking-detail-stake-button'
          >
            {trans.staking.modal.stake}
          </Button>
        )}
      </Stack>
      {popupState.isOpen && popupState.type === STAKING && <StakeUnstakeForm />}
    </Stack>
  )
}

export default Stake
